import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {FooterComponent} from './footer/footer.component';
import {DxSelectBoxModule, DxLoadIndicatorModule} from 'devextreme-angular';

@NgModule({
  declarations: [
    FooterComponent,
  ],
    imports: [
        CommonModule,
        DxSelectBoxModule,
        ReactiveFormsModule,
    ],
  exports: [
    FooterComponent
  ],
})

export class CoreModule {
}
